import {inject, Injectable} from '@angular/core';
import {ApiResponse, MesApiService, UserModel, UserQuery, UsersStore} from 'common-shared';
import {Observable} from 'rxjs';
import {Exclude, plainToInstance} from 'class-transformer';
import {map} from 'rxjs/operators';
import {SpecLineModel} from "../../properties/models/spec-line.model";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from "@angular/router";

export class WebUserModel extends UserModel{
    @Exclude() Specs: SpecLineModel[];
}

@Injectable({
  providedIn: 'root'
})
export class UserService extends MesApiService {
  router: Router = inject(Router)
  constructor(private store: UsersStore) {
    super('user');
  }

  getByRoleOrPrivilege(roleId?: string, privilegeId?: string) {
    return this.getList<UserQuery>({
      action: 'GetByRoleOrPrivilege'
    }, {
      roleId: roleId,
      privilegeId: privilegeId
    }).pipe(map(value => {
      return plainToInstance(UserQuery, value.data);
    }));
  }

  getWithRoles() {
    return this.getList<UserModel>({action: 'GetWithRoles'}).pipe(map(value => {
      return plainToInstance(UserModel, value.data);
    }));
  }

  getCurrent(): Observable<ApiResponse<UserModel>> {
    return this.getSingle<UserModel>({action: 'Current'});
  }

  getCurrentUserViewModel(): Observable<UserModel> {
    return this.getSingle<UserModel>({action: 'GetCurrentUser'})
      .pipe(map(value => plainToInstance(UserModel, value.data)));
  }

  loadOne(id: string): Observable<UserModel> {
    return this.getSingle<UserModel>({id})
      .pipe(map(value => plainToInstance(UserModel, value.data)));
  }

  addNew(user: UserModel) {
    return this.add<UserModel>(user).pipe(map(value => {
      this.store.loadAll(value.data.Id).subscribe();
      return plainToInstance(UserModel, value.data)
    }));
  }

  save(user: UserModel): Observable<UserModel> {
    return this.update<UserModel>(user.Id, user).pipe(map(value => {
      this.store.loadAll(value.data.Id).subscribe();
      return plainToInstance(UserModel, value.data);
    }));
  }

  saveCurrentUser(user: UserModel): Observable<UserModel> {
    return this.update<UserModel>(user.Id, user, {action: 'SaveCurrentUser'})
      .pipe(map(value => plainToInstance(UserModel, value.data)));
  }

  remove(user: UserModel) {
    return this.delete<UserModel>(user.Id).pipe(map(value => {
      this.store.loadAll(user.Id).subscribe();
      return plainToInstance(UserModel, value.data);
    }));
  }

  getCurrentUserSpecs(): Observable<SpecLineModel[]> {
    return this.getList<SpecLineModel>({area: 'manufacturing', controller: 'resource', action: 'GetCurrentUserSpecs'}).pipe(map(value => {
      return plainToInstance(SpecLineModel, value.data);
    }));
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getCurrent().pipe(map(value => {
      const canActivate = value.data.Privileges.includes(route.data.expectedPrivilege);
      if(this.router.routerState.snapshot.url.includes('login')){
        this.router.navigate(['/']).then(r => console.log(r));
      }
      return canActivate;
    }));
  }
}
